var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FF2A985A-F129-4D49-8776-94209597689C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cotizap---Internas",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cotizap-1.0.0.0---Bodegas",
    transform: "translate(-1188.000000, -143.000000)",
    fill: "#226095"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1188.000000, 143.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Download-Copy-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,7 C12.4142204,7 12.75,7.20806991 12.75,7.46474666 L12.75,7.46474666 L12.75,11.786 L17.0156863,11.7861267 C17.3062745,11.7926372 17.466098,11.986034 17.4951569,12.3663172 L17.5,12.5 C17.5,12.9686817 17.3385621,13.2066395 17.0156863,13.2138733 L17.0156863,13.2138733 L12.75,13.213 L12.75,17.5156863 C12.743091,17.8092098 12.5358513,17.9693135 12.128281,17.9959974 L12,18 C11.5076,18 11.2576,17.8385621 11.25,17.5156863 L11.25,17.5156863 L11.25,13.213 L6.96474666,13.2138733 C6.73373759,13.2138733 6.54210005,12.9549929 6.50608263,12.6157955 L6.5,12.5 C6.5,12.1057321 6.70806991,11.7861267 6.96474666,11.7861267 L6.96474666,11.7861267 L11.25,11.786 L11.25,7.46474666 C11.25,7.23140416 11.5275038,7.0382326 11.8891689,7.00503895 Z",
    id: "Combined-Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,1.5 C6.20963645,1.5 1.5,6.20963645 1.5,12 C1.5,17.7903635 6.20963645,22.5 12,22.5 C17.7903635,22.5 22.5,17.7903635 22.5,12 C22.5,6.20963645 17.7903635,1.5 12,1.5 Z M12,3 C16.9623904,3 21,7.03760956 21,12 C21,16.9623904 16.9623904,21 12,21 C7.03760956,21 3,16.9623904 3,12 C3,7.03760956 7.03760956,3 12,3 Z",
    id: "Combined-Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMore);
export default __webpack_public_path__ + "static/media/icon-more.62c2808d07eb7442b3a3c752f579444c.svg";
export { ForwardRef as ReactComponent };